/**
 * CircleCollider2D Component
 *
 * Circle collision shape for 2D physics.
 */

import {
  component,
  displayName,
  icon,
  color,
  category,
  allowMultiple,
  requireComponent,
  field,
  customEditor,
} from "../attributes";

@component("core.CircleCollider2D")
@customEditor("CircleCollider2DEditor")
@displayName("Circle Collider 2D")
@icon("Circle")
@color("#00b894")
@category("Physics 2D")
@allowMultiple(true)
@requireComponent(["core.Transform"])
export class CircleCollider2D {
  /** Offset from transform center */
  @field({ type: "vec2", label: "Offset" })
  offset: { x: number; y: number } = { x: 0, y: 0 };

  /** Radius */
  @field({ type: "f32", label: "Radius", min: 0.01, step: 0.1 })
  radius: number = 0.5;

  /** Is trigger (no collision response, only events) */
  @field({ type: "bool", label: "Is Trigger" })
  isTrigger: boolean = false;

  /** Whether this collider casts 2D shadows */
  @field({ type: "bool", label: "Cast Shadow", group: "Shadow" })
  castShadow: boolean = false;

  /** Physics material */
  @field({ type: "f32", label: "Friction", min: 0, max: 1, step: 0.01, group: "Material" })
  friction: number = 0.4;

  @field({ type: "f32", label: "Bounciness", min: 0, max: 1, step: 0.01, group: "Material" })
  bounciness: number = 0;

  @field({ type: "f32", label: "Density", min: 0.01, step: 0.1, group: "Material" })
  density: number = 1;

  /** How to combine friction when colliding (0=Avg, 1=Min, 2=Max, 3=Multiply) */
  @field({ type: "i32", label: "Friction Combine", group: "Material", hidden: true })
  frictionCombine: number = 0;

  /** How to combine bounciness when colliding (0=Avg, 1=Min, 2=Max, 3=Multiply) */
  @field({ type: "i32", label: "Bounciness Combine", group: "Material", hidden: true })
  bouncinessCombine: number = 0;

  /** One-way platform - allows passing through from one side */
  @field({ type: "bool", label: "One-Way Platform", hidden: true })
  oneWay: boolean = false;

  /** Direction of one-way (normal pointing to "solid" side), typically (0,1) for top-solid */
  @field({ type: "vec2", label: "One-Way Direction", hidden: true })
  oneWayDirection: { x: number; y: number } = { x: 0, y: 1 };

  /** Collision layer */
  @field({ type: "i32", label: "Layer", hidden: true })
  layerMask: number = 1;

  /** Collision mask */
  @field({ type: "i32", label: "Collision Mask", hidden: true })
  collisionMask: number = 0xFFFF;
}
